import './DAcRegistration.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem } from '../../utils';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DAcRegistrationForm from './components/DAcRegistrationForm';
import DAcConfirmation from '../DAcConfirmation/DAcConfirmation';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
const DAcRegistration = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [showBanner, setShowBanner] = useState(false);
  const [email, setEmail] = useState('');
  const {
    data: {
      configuration,
      dictionary,
      settings
    }
  } = fields;
  const apiKey = get(settings, 'apiKey.jss.value');
  const apiUrl = get(settings, 'apiUrl.jss.value');
  getDictionaryItem(dictionary, 'password');
  getDictionaryItem(dictionary, 'username');
  const bannerFields = {
    data: {
      configuration: {
        title: configuration.invitationSectionTitle,
        shortDescription: configuration.invitationSectionDescription,
        image: configuration.invitationImage,
        description: {
          jss: {
            value: (get(configuration, 'invitationDescription.jss.value') || '').replace('$email$', email)
          }
        },
        // inside
        contentTitle: configuration.invitationTitle,
        // inside
        buttonLabel: {
          jss: {
            value: getDictionaryItem(dictionary, 'continueToApplication')
          }
        },
        buttonUrl: configuration.invitationButtonLink
      }
    }
  };
  const banenrProcessed = (state, email) => {
    setShowBanner(state);
    setEmail(email);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !showBanner ? /*#__PURE__*/React.createElement("div", {
    className: "dac-login"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: get(configuration, 'registrationTitle.jss'),
    className: "dac-login__title"
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    field: get(configuration, 'registrationDescription.jss'),
    className: "dac-login__description"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap"
  }, /*#__PURE__*/React.createElement(DAcRegistrationForm, {
    redirectToBanner: banenrProcessed,
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey,
      apiUrl
    },
    rtl: rtl
  })), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__intro"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    field: get(configuration, 'introText.jss'),
    className: "body-large "
  }), /*#__PURE__*/React.createElement(Link, {
    className: `btn btn-secondary`,
    field: {
      href: get(configuration, 'introButtonLink.jss.value.href')
    }
  }, get(configuration, 'introButtonTitle.jss.value')))) : /*#__PURE__*/React.createElement(DAcConfirmation, {
    rtl: rtl,
    fields: bannerFields,
    params: params
  }));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default DAcRegistration;
const commonStyles = "c5znr9e";
const ltrStyles = "lx0mrdn";
const rtlStyles = "r15jhcl8";